import { useTranslation } from 'react-i18next';

import { SchibstedIcon } from '../Icon/Icon';
import { config } from '../../config';

import * as styles from './DataController.module.scss';

export function DataController() {
  const { t } = useTranslation();
  return (
    <div className={styles.container} data-nosnippet>
      <SchibstedIcon />
      <p>
        {t('Data controller')}{' '}
        <a
          rel="noopener nofollow"
          target="_blank"
          href={config.dataController.link}
        >
          {t('Read more here')}
        </a>
      </p>
    </div>
  );
}
